import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getFormDataAction } from '../actions';

const {
  useLoaderData: useSessionFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getFormDataAction,
});

function SessionFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { SessionFormLoader, useSessionFormLoaderData };
